<template>
  <div class="play-video" v-if="seen">
    <div class="video-loader" v-if="!play">
      <span>
        <svg
          width="120px"
          height="120px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          preserveAspectRatio="xMidYMid"
          class="lds-dual-ring"
          style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;"
        >
          <circle
            cx="50"
            cy="50"
            fill="none"
            stroke-linecap="round"
            r="20"
            stroke-width="4"
            stroke="#039aed"
            stroke-dasharray="31.41592653589793 31.41592653589793"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              calcMode="linear"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
              dur="1s"
              begin="0s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </span>
      <span>Loading file....</span>
    </div>
    <div class="player" v-if="play">
      <div class="controls">
        <span>
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="#888888" d="M19,13H5V11H19V13Z" />
          </svg>
        </span>
        <span>
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="#888888" d="M4,4H20V20H4V4M6,8V18H18V8H6Z" />
          </svg>
        </span>
        <span class="close" @click="close_box">
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path
              fill="#888888"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
            />
          </svg>
        </span>
      </div>
      <vue-plyr>
        <video controls class="img-fluid">
          <source :src="src" :type="format" />
        </video>
      </vue-plyr>
    </div>
  </div>
</template>
<style scoped>
.close {
  cursor: pointer;
}
</style>

<script>
import { setTimeout } from "timers";
import config from "@/services/config";
import cookies from "@/services/cookies";
export default {
  data() {
    return {
      seen: false,
      src: "",
      format: "",
      play: false,
      id: "",
    };
  },
  methods: {
    logincall() {
      this.$parent.logincall();
    },
    load(id) {
      let that = this;

      this.seen = true;
      this.src = "";
      this.play = false;
      this.id = id;

      let data = {
        token: cookies.getCookie("token"),
        id: id,
      };

      const src = `${process.env.VUE_APP_FILE_WATCHER_SERVER}/files/${id}`;
      that.src = src;
      that.format = data.format;
      setTimeout(function () {
        that.play = true;
      }, 2000);

      // this.$socket.emit('load-video', data, function(data) {
      //     if(data.data === true) {
      //         const src = `${process.env.VUE_APP_FILE_WATCHER_SERVER}/files/${id}`;
      //         // that.src = process.env.VUE_APP_HTTP+'://'+config.origin+':'+process.env.VUE_APP_PORT+'/video/'+id+'/'+cookies.getCookie('token')
      //         that.src = src;
      //         that.format = data.format
      //         setTimeout(function() {
      //             that.play = true
      //         }, 2000)
      //     }

      //     if(data.data === false) {
      //         that.seen = false
      //         that.logincall()
      //     }
      // })
    },
    close_box(evt) {
      this.seen = false;
      this.src = "";
      this.play = false;

      let data = {
        token: cookies.getCookie("token"),
        fileid: this.id,
      };
    //   this.$socket.emit("deleteblock", data);
    },
  },
};
</script>